// TEMPORARY COMPAT SHIM.
//
// React 19 removed ReactDOM.findDOMNode from the public API. Callers that still reach for it throw,
// React unmounts the whole tree, and the app renders a blank page.
//
// Originally this existed for semantic-ui-react's <Ref> (via @fluentui/react-component-ref). Semantic UI
// is gone now, but ONE caller remains: react-overlays/safeFindDOMNode, pulled in by react-big-calendar
// (RecipeCalendarPage). It is guarded -- it only calls findDOMNode for class-component instances -- but it
// is reachable, so the shim has to stay until react-big-calendar is replaced or upgraded past it.
//
// To check whether it is still needed:  grep '\.findDOMNode(' debugDist/assets/main-*.js
//
// React 19 only removed the *export*: react-dom/client still installs the real implementation on
// react-dom's internals object. So re-export everything react-dom exports, plus findDOMNode, and
// have esbuild alias "react-dom" to this file (see withEsbuildOptions in build.sbt).
//
// The import below uses a relative path so it bypasses the alias and reaches the real package.
// Do NOT import react-dom/client here: it imports "react-dom", which the alias points back at this
// file, and the resulting cycle leaves these exports uninitialised. The app loads react-dom/client
// itself (createRoot), which is what installs findDOMNode on the internals -- so look it up lazily,
// at call time, by which point it is always present.
import ReactDOM from "./node_modules/react-dom/index.js";

export function findDOMNode(componentOrElement) {
  const internals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  if (typeof internals?.findDOMNode !== "function") {
    throw new Error("react-dom-compat: findDOMNode is unavailable in this react-dom build");
  }
  return internals.findDOMNode(componentOrElement);
}

export const {
  __DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
  createPortal,
  flushSync,
  preconnect,
  prefetchDNS,
  preinit,
  preinitModule,
  preload,
  preloadModule,
  requestFormReset,
  unstable_batchedUpdates,
  useFormState,
  useFormStatus,
  version,
} = ReactDOM;

export default { ...ReactDOM, findDOMNode };
